module.exports = __webpack_public_path__ + "static/media/UniNeueBook.b97168cd.woff";